module.exports = __webpack_public_path__ + "img/Pag2.312d1d88.png";